import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { storage } from '@uhg-abyss/web/tools/storage';
import { Button } from '@src/common/Button';
import { useUser } from '@src/state/user';
import { config } from '@uhg-abyss/web/tools/config';
import { Countdown } from '../../Countdown';
import { RESET_TIME, HAS_SIGNED_OUT } from '../constants';

export const IdleModal = ({
  events,
  timeRemaining,
  pingInterval,
  isOpen,
  closeModal,
}) => {
  const [originalExpiredTime, setOriginalExpiredTime] = useState();
  const { uuid } = useUser.state();
  const isSuperUser = storage.local.get(uuid);

  useEffect(() => {
    setOriginalExpiredTime(storage.local.get(RESET_TIME));
  }, [isOpen]);

  const handleSignout = () => {
    storage.local.set(HAS_SIGNED_OUT, true);
    if (config('US3671382_SUPER_USER') && isSuperUser) {
      storage.local.remove(uuid);
    }

    events.onSignout();
  };

  const handleTimeout = () => {
    handleSignout();
  };

  const handleTick = (timeMS) => {
    if (originalExpiredTime !== storage.local.get(RESET_TIME)) {
      closeModal();
    }

    if (storage.local.get(HAS_SIGNED_OUT)) {
      events.onSignout();
    }
    const tickInterval = Math.floor((timeMS % pingInterval) / 1000);

    if (tickInterval === 0) {
      events.onIdleTick(timeMS);
    }
  };

  return (
    <Modal
      width={600}
      isOpen={isOpen}
      hideClose
      onClose={closeModal}
      title="Session Timeout Warning"
      footer={
        <Modal.Section>
          <Layout.Group alignLayout="right">
            <Button variant="outline" onClick={handleSignout}>
              Sign Out
            </Button>
            <Button onClick={closeModal}>Continue Working</Button>
          </Layout.Group>
        </Modal.Section>
      }
    >
      <Modal.Section>
        <div>
          You will be signed out in a few minutes due to inactivity. All unsaved
          data on this page will be lost.
        </div>
        <div>
          Time remaining:{' '}
          <Countdown
            countdownMS={timeRemaining}
            onTick={handleTick}
            onComplete={handleTimeout}
          />
        </div>
      </Modal.Section>
    </Modal>
  );
};

IdleModal.propTypes = {
  timeRemaining: PropTypes.number.isRequired,
  pingInterval: PropTypes.number.isRequired,
  events: PropTypes.shape({
    onIdleTimeout: PropTypes.func,
    setIdleRecovery: PropTypes.func,
    onIdleTick: PropTypes.func,
    onSignout: PropTypes.func,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};
